import * as yup from 'yup';

export const resendActivationSchema = yup.object().shape({
  email: yup.string().required().email()
});
